import { render, staticRenderFns } from "./apefa.vue?vue&type=template&id=789efa6e&scoped=true"
import script from "./apefa.vue?vue&type=script&lang=js"
export * from "./apefa.vue?vue&type=script&lang=js"
import style0 from "./apefa.vue?vue&type=style&index=0&id=789efa6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789efa6e",
  null
  
)

export default component.exports